import React, { useEffect, useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
export const UrgencyCountdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 52,
    seconds: 36
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <SectionWrapper className="bg-[#A05A35] py-16 px-4" data-id="element-414">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-415">
        <h2 className="font-playfair text-[28px] md:text-[36px] font-bold text-white mb-8" data-id="element-416">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>

        <div className="flex justify-center items-center gap-4 md:gap-8 mb-8" data-id="element-417">
          <div className="flex flex-col items-center" data-id="element-418">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 text-white font-playfair text-4xl md:text-6xl font-bold w-20 h-24 md:w-28 md:h-32 flex items-center justify-center rounded-xl shadow-lg" data-id="element-419">
              {formatTime(timeLeft.hours)}
            </div>
            <span className="font-poppins text-white/80 text-sm mt-3 uppercase tracking-wider font-medium" data-id="element-420">
              Horas
            </span>
          </div>
          <div className="text-white/50 font-playfair text-4xl md:text-6xl font-bold pb-8" data-id="element-421">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-422">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 text-white font-playfair text-4xl md:text-6xl font-bold w-20 h-24 md:w-28 md:h-32 flex items-center justify-center rounded-xl shadow-lg" data-id="element-423">
              {formatTime(timeLeft.minutes)}
            </div>
            <span className="font-poppins text-white/80 text-sm mt-3 uppercase tracking-wider font-medium" data-id="element-424">
              Minutos
            </span>
          </div>
          <div className="text-white/50 font-playfair text-4xl md:text-6xl font-bold pb-8" data-id="element-425">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-426">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 text-white font-playfair text-4xl md:text-6xl font-bold w-20 h-24 md:w-28 md:h-32 flex items-center justify-center rounded-xl shadow-lg" data-id="element-427">
              {formatTime(timeLeft.seconds)}
            </div>
            <span className="font-poppins text-white/80 text-sm mt-3 uppercase tracking-wider font-medium" data-id="element-428">
              Segundos
            </span>
          </div>
        </div>

        <p className="font-poppins text-[18px] font-bold text-gold mb-8 bg-black/20 inline-block px-6 py-2 rounded-full shadow-inner" data-id="element-429">
          ⚠️ Después sube $10.000 ARS. No vuelve.
        </p>

        <div className="max-w-[500px] mx-auto bg-black/10 p-5 rounded-xl border border-white/10" data-id="element-430">
          <div className="flex items-center justify-between mb-3 font-poppins text-sm text-white" data-id="element-431">
            <div className="flex items-center gap-2" data-id="element-432">
              <span className="w-2.5 h-2.5 rounded-full bg-red-400 animate-pulse shadow-[0_0_8px_rgba(248,113,113,0.8)]" data-id="element-433"></span>
              Cupos al precio de lanzamiento
            </div>
            <span className="font-bold text-gold" data-id="element-434">68% tomados</span>
          </div>
          <div className="w-full h-3 bg-black/20 rounded-full overflow-hidden shadow-inner" data-id="element-435">
            <div className="h-full bg-sage rounded-full w-[68%] relative" data-id="element-436">
              <div className="absolute inset-0 bg-white/20 animate-[shimmer_2s_infinite]" data-id="element-437"></div>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
};